import { Transition } from '@headlessui/react';
import React from 'react';

// Hard to type this until @headlessui/react gets their types reasonably consumable...
type Props = any & {
  show: boolean;
};

const ScaleFromTopFade: React.FC<Props> = ({ children, ...props }) => (
  <Transition
    {...props}
    enter="transition transform duration-300 origin-top"
    enterFrom="opacity-0 scale-95"
    enterTo="opacity-100 scale-100"
    leave="transition transform opacity-100 duration-300 origin-top"
    leaveFrom="opacity-100 scale-100"
    leaveTo="opacity-0 scale-95"
  >
    {children}
  </Transition>
);

export default ScaleFromTopFade;
